import { RestSlice } from '../../redux/rest.slice';
import { Resource, localizationService } from 'src/services';
import { SystemAuthority } from '@rcp/types';

export const systemAuthoritiesSlice = new RestSlice<SystemAuthority>(
	localizationService.getLocalizedString('systemAuthority.authorities'),
	Resource.SystemAuthorities
);
export default systemAuthoritiesSlice.rests.reducer;
